import { Component,OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../config';
import { MdDialog,MdDialogRef } from '@angular/material';
import { HttpService } from '../shared/services/http.service'
import { LayoutService } from '../layout/layout.service'
import { SessionHandler } from '../shared/services/session-handler.service';
import { CommonService } from '../shared/services/common.service';
import { Subject }    from 'rxjs/Subject';
import { DaterangepickerConfig } from 'ng2-daterangepicker';

// Dialog box for add and edit maintenance tables entity
// openDialog
@Component({
    template: require('./foc-addApprover.component.html'),
    styles: [require('./foc-addApprover.component.scss')],
    providers: [HttpService,SessionHandler]
})
export class FOCaddApproverComponent implements OnInit {
	approverChange:Subject<string>= new Subject<string>();
    action:any;
    orderType:any;
    roleType:any;
    email:any;
    fromDate:any;
    toDate:any;
    formData:any={};
    approverMailList:any;
    errorMsg:any;
    loader:boolean=false;
    sold_To: any;
    primaryApproverEmail: any;
    loggedInUserId: any;


    constructor(private router: Router,private http:HttpService,private commonService:CommonService,private sessionHandler:SessionHandler,
        private dialog: MdDialog,public dialogRef: MdDialogRef<FOCaddApproverComponent>,private daterangepickerOptions: DaterangepickerConfig) {
            const loginDataRaw = this.sessionHandler.getItem('loginData');
            const loginData = loginDataRaw ? JSON.parse(loginDataRaw) : null;
        
            this.loggedInUserId = loginData ? loginData.userId : null;

            console.log(dialogRef)
            console.log(this.orderType)
        }

    ngOnInit():void {
        var today = new Date();
        if(!this.fromDate && !this.toDate){
        /**OLd one */
        // this.fromDate = today.getFullYear()+'-'+today.getMonth()+1+'-'+today.getDate();
        // this.toDate = today.getFullYear() +'-'+today.getMonth()+1+'-'+today.getDate();
        /** */
        /**New one */
        let currentMonth = today.getMonth()+1;
        this.fromDate = today.getFullYear()+'-'+currentMonth+'-'+today.getDate();
        this.toDate = today.getFullYear() +'-'+currentMonth+'-'+today.getDate();
        /** */
        console.log
        this.daterangepickerOptions.settings = {
            locale: { format: 'YYYY-MMM-D' },
            startDate:new Date(today.getFullYear(),today.getMonth(),today.getDate()),
            endDate:new Date(today.getFullYear(),today.getMonth(),today.getDate()),
            alwaysShowCalendars: false,
            buttonClasses: "btn btn-md",
            opens : 'center'
        };
        } else {
            this.daterangepickerOptions.settings = {
                locale: { format: 'YYYY-MMM-D' },
                startDate:new Date(this.fromDate),
                endDate:new Date(this.toDate),
                alwaysShowCalendars: false,
                buttonClasses: "btn btn-md",
                opens : 'center'
            };
        }
    }

    public selectedDate(value: any) {
        this.fromDate = value.start.format('YYYY-MM-DD');
        this.toDate = value.end.format('YYYY-MM-DD')
    }

    public checkEmail(){
        if (/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/.test(this.email) == true)
        {
            this.errorMsg = null;
        }
    }


    public delete(action){
        this.formData.orderType = this.orderType;
        this.formData.sold_to = this.sold_To;
        this.formData.primary_approver_email = this.primaryApproverEmail;  // primary approver
        if(this.roleType == 'Commercial Approver'){
            this.formData.roleType = 'commercial';
        }
        if(this.roleType == 'Logistic Approver'){
            this.formData.roleType = 'logistic';
        }
        if(this.roleType == 'End Consumer Approver'){
            this.formData.roleType = 'endconsumer';
        }
        this.loader = true;
        this.errorMsg = null;
        this.formData.userId = this.loggedInUserId;


        this.http.postRequest(this.formData,'focApproverOperationsApi/v1/deleteAdditionalApprover').subscribe(
            res => {
                this.saveResponse(res,action);
                },
                err => {
                    this.errorMsg = err;
                    this.http.onEnd();
                }
        );
    }

    

    public save(action) {
        if (this.email == null || this.email == '') {
          this.errorMsg = 'Email is Required.Please enter valid email.';
        } else {
          this.formData.additionalApproverEmail = this.email;              // additional approver
          this.formData.primaryApproverEmail = this.primaryApproverEmail;  // primary approver
      
          this.formData.fromDate = this.fromDate;
          this.formData.toDate = this.toDate;
          this.formData.orderType = this.orderType;
          this.formData.soldTo = this.sold_To;
      
          if (this.roleType == 'Commercial Approver') {
            this.formData.roleType = 'commercial';
          }
          if (this.roleType == 'Logistic Approver') {
            this.formData.roleType = 'logistic';
          }
          if (this.roleType == 'End Consumer Approver') {
            this.formData.roleType = 'endconsumer';
          }
      
          this.loader = true;
          this.errorMsg = null;
          this.formData.userId = this.loggedInUserId;
      
          this.http.postRequest(this.formData, 'focApproverOperationsApi/v1/addAdditionalApprover')
            .subscribe(
              res => this.saveResponse(res, action),
              err => {
                this.errorMsg = err;
                this.http.onEnd();
              }
            );
        }
      }
      

    public saveResponse(res,action){
        this.loader = false;
        if(res.responseCode != '200'){
            this.errorMsg = res.errorMessage; 
        } else {
            this.commonService.changeApproverData(action);
            this.dialogRef.close(action);
        }
        this.http.onEnd();
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/foc-admin/foc-addApprover.component.ts